import getGenericUseCase from 'use-case/genericUseCase';
import StoredAnalysis from 'domain/entity/storedAnalysis';
import ReadStoredAnalysisCriteria from 'use-case/storedAnalysis/read/readStoredAnalysisCriteria';

const getReadStoredAnalysisUseCase = getGenericUseCase<StoredAnalysis, ReadStoredAnalysisCriteria>((client, criteria) => client(criteria));

export default getReadStoredAnalysisUseCase;
